// It's an array because levels are saved as a 0-based index
export const PROMOTING_TIERS = ["Mini", "Hype", "Mega"] as const

export default PROMOTING_TIERS
